import React from "react";
import Checkbox from "@mui/material/Checkbox";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import DataTable, {
  defaultThemes,
  TableProps,
} from "react-data-table-component";
import { color } from "../../utils/theme";

const sortIcon = <ArrowDownwardIcon />;
const selectProps = {
  indeterminate: (isIndeterminate: boolean) => isIndeterminate,
};
const customStyles = {
  header: {
    style: {
      minHeight: "70px",
      color: color.primary,
      fontWeight: "700 !important",
    },
  },
  headRow: {
    style: {
      borderTopColor: defaultThemes.default.divider.default,
      backgroundColor: "#f1f1f1",
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },
  headCells: {
    style: {
      fontSize: "14px",
      fontWeight: "bold",
      color: color.primary,
    },
  },
  cells: {
    style: {
      fontSize: "14px",
      minHeight: "35px",
      borderRightColor: defaultThemes.default.divider.default,
    },
  },
};

function DataTableBase<T>(props: TableProps<T>) {
  return (
    <DataTable
      pagination
      customStyles={customStyles}
      selectableRowsComponentProps={selectProps}
      sortIcon={sortIcon}
      dense
      {...props}
    />
  );
}

export default DataTableBase;
